import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {Typography} from '@mui/material';
import {APIError} from '~common/lib/types';
import URLManager from '~common/lib/url-manager';
import classNames from 'classnames';
import Renderers from '~common/lib/renderers';
import {SummaryCard} from '~common/components/query-fulfillment/query-results-summary-card';

const styles = (theme: Theme): StyleRules => ({
  container: {
    flex: 1,
  },
  cardContent: {
    margin: '10px 15px 10px 15px',
    height: 'calc(100% - 70px)',
    userSelect: 'none',
  },
  multiCountContent: {
    display: 'flex',
    flexWrap: "wrap",
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    width: '100%',
    // height: '100%',
    userSelect: 'none',
  },
  multiCountItem: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: "wrap",
    flexGrow: 4,
    // flexBasis: 0,
    flexShrink: 1,
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    // width: "calc(100%-50px)",
    height: '100%',
    cursor: 'pointer'
  },
  caption: {
    // borderBottom: '1px solid #ccc',
    display: 'flex',
    margin: '10px 15px 10px 15px',
    justifyContent: 'center',
    alignItems: 'flex-end',
    // minHeight: 120,
    // fontSize: '1.0rem',
    width: '100%',
    height: '30%',
    cursor: 'pointer'
},
  countContent: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    // minHeight: 120,
    // fontSize: '3.0rem',
    width: '100%',
    height: '70%',
    cursor: 'pointer'
  },
  contentContainer: {
    display: 'flex',
    flexWrap: "wrap",
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    // height: '100%',
  },

  // This one is for the summary card
  // Added calc to height
  summaryCard: {
    width: "100%",
    margin: 0,
    height: 'calc(100% - 15px)',
    // height: '100%'
    border: 0,
  }

});

interface Props {
  id: number;
  renderers: any;
  element: any;

  chromeless?: boolean;

  elementType: any;

  inEditMode?: boolean;


}

type State = {
  status: 'loading' | 'ready';
  data: any;
  error?: any;
};

class AggregationRenderer extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      data: null
    };
  }

  // UNSAFE_componentWillReceiveProps(
  //   newProps: Props & WithStyles<keyof typeof styles>
  // ) {}

 componentDidMount() {
    const self = this;
    if (!this.props.element || !this.props.element.id) {
      console.error("No ID found on Props")
    } else {
   
    request
      .get('/api/dashboards/' + this.props.element.id)
      .set('accept', 'application/json')
      .send()
      .then((response) => {
        self.setState({status: 'ready', data: response.body});
      })
      .catch((err) => {
        if (err.response && err.response.text) {
          const apiErr = new APIError();
          apiErr.type = 'http';
          apiErr.message = err.response.text;
          self.setState({status: 'ready', error: apiErr});
        }
      });
    }
  }

  static register = () => {
   
    if(!Renderers.find("AggregationElementRenderer")){
     
      Renderers.register("AggregationElementRenderer", withStyles(styles)(AggregationRenderer))
    }
  }

  onAggregationClick = (evt:any) => {
    const { element } = this.props;
    
   
    if (
      element.fulfillmentCriteria &&
      element.elementAttributes &&
      element.elementAttributes.targetURL
    ) {
      const reducedCrit = this.reduceCriteria(element.fulfillmentCriteria);

      var url: string = element.elementAttributes.targetURL;
      url += '?q=' + URLManager.getQueryStringValue(reducedCrit);
      window.location.href = url;
    }
  };

  reduceCriteria = (crit: any) => {
    delete crit['criteriaForm'];
    delete crit['resultsForm'];
    return crit
  };

  getThresholdAttributes = (): any => {
    const {data} = this.state;

    let attr = {};
   

    if (
      data.element.elementAttributes &&
      data.element.elementAttributes.thresholds
    ) {
      const thresholds = data.element.elementAttributes.thresholds;
     

      if (thresholds.defaultAttributes) {
        attr = thresholds.defaultAttributes;
      }
      if (thresholds.entries) {
        var sorted = thresholds.entries.sort((a, b) => {
          return a.value > b.value;
        });

        for (let i of sorted) {
          if (i.floorValue <= data.content.count && i.attributes) {
            attr = i.attributes;
          }
        }
      }
    }

    return attr;
  };

  renderAggregation = (
    aggregation: any,
    idx: number
  ) => {
    const {classes}: {classes: ClassNameMap} = this.props;
    const styleAttributes = this.getThresholdAttributes();
   
    return (
      <div key={'agg_render_'+idx} className={classes.multiCountItem} onClick={this.onAggregationClick(idx)}>
        <Typography className={classes.caption} variant="subtitle1">
        <label >{aggregation.label}</label>
        </Typography>
        <div
        // onClick={this.onCountClick(idx)}
        className={classes.countContent}
        style={styleAttributes}>
        {aggregation.value}
        </div>
      </div>
        
    );
  };
  

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {chromeless, renderers} = this.props;
    const {status, data} = this.state;

    var cardContent: any = null;
   
    switch (status) {
      case 'loading':
        return (
          <div className={classes.container}>
            <LoadingView compact classes={{}} />
          </div>
        );

      default:
        if (data && data.element && data.element.elementType) {
          const styleAttributes = this.getThresholdAttributes();

          var renderer: any = null;
          var cardClasses: any = {
            card: classes.summaryCard
          };


          // console.log(data)
         
          cardContent = (
            <SummaryCard suppressTitle classes={cardClasses} data={data.summary} onClick={this.onAggregationClick} />
          );
        }
    }

    return  cardContent; 

  }
}

export default withStyles(styles)(AggregationRenderer);

